
export default {
  name: 'PromoCodeConditionsModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    code: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getClientTypeText(code) {
      // Utiliser le champ account_type du backend
      if (!code.account_type) {
        return this.$t('pages.codesPromo.index.forAllClients')
      }

      const accountTypeIdentifier = code.account_type.identifier
      if (accountTypeIdentifier === 'pro') {
        return this.$t('pages.codesPromo.index.forProfessionalsOnly')
      }
      if (accountTypeIdentifier === 'individual') {
        return this.$t('pages.codesPromo.index.forIndividualsOnly')
      }
      return this.$t('pages.codesPromo.index.forAllClients')
    },
    getBrandsText(code) {
      // Vérifier les marques sélectionnées et exclues
      const hasSelectedBrands = code.selected_brands && code.selected_brands.length > 0
      const hasExcludedBrands = code.excluded_brands && code.excluded_brands.length > 0

      // Si des marques sont spécifiquement sélectionnées
      if (hasSelectedBrands) {
        const brandNames = code.selected_brands.map(b => b.name).join(', ')
        return this.$t('pages.codesPromo.index.selectedBrands', { brands: brandNames })
      }

      // Si des marques sont exclues
      if (hasExcludedBrands) {
        const brandNames = code.excluded_brands.map(b => b.name).join(', ')
        return this.$t('pages.codesPromo.index.excludedBrands', { brands: brandNames })
      }

      return this.$t('pages.codesPromo.index.allProducts')
    },
    getCumulableText(code) {
      // Utiliser le champ can_be_combined_with_discounts du backend
      if (code.can_be_combined_with_discounts) {
        return this.$t('pages.codesPromo.index.cumulableYes')
      }
      return this.$t('pages.codesPromo.index.cumulableNo')
    },
    getValidityPeriodText(code) {
      const dateTo = code.date_to ? new Date(code.date_to).toLocaleDateString(this.$i18n.locale) : null

      if (dateTo) {
        return this.$t('pages.codesPromo.index.validUntil', { date: dateTo })
      }
      return this.$t('pages.codesPromo.index.noExpiration')
    },
  },
}
